module.exports = __webpack_public_path__ + "static/media/TRIDENT_CAROUSEL-3.36fb78e7.jpg";